"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthFlowProofCookiesRemoveOptions = exports.createAuthFlowProofCookiesSetOptions = exports.createSignOutFlowProofCookies = exports.createSignInFlowProofCookies = void 0;
const constant_1 = require("../constant");
const origin_1 = require("./origin");
const createSignInFlowProofCookies = ({ state, pkce, }) => [
    {
        name: constant_1.PKCE_COOKIE_NAME,
        value: pkce,
    },
    {
        name: constant_1.STATE_COOKIE_NAME,
        value: state,
    },
];
exports.createSignInFlowProofCookies = createSignInFlowProofCookies;
const createSignOutFlowProofCookies = () => [
    {
        name: constant_1.IS_SIGNING_OUT_COOKIE_NAME,
        value: 'true',
    },
    {
        name: constant_1.IS_SIGNING_OUT_REDIRECTING_COOKIE_NAME,
        value: 'true',
    },
];
exports.createSignOutFlowProofCookies = createSignOutFlowProofCookies;
const createAuthFlowProofCookiesSetOptions = (setCookieOptions, origin) => ({
    domain: setCookieOptions?.domain,
    path: '/',
    httpOnly: true,
    secure: (0, origin_1.isSSLOrigin)(origin),
    sameSite: 'lax',
    maxAge: constant_1.AUTH_FLOW_PROOF_MAX_AGE,
});
exports.createAuthFlowProofCookiesSetOptions = createAuthFlowProofCookiesSetOptions;
const createAuthFlowProofCookiesRemoveOptions = (setCookieOptions) => ({
    domain: setCookieOptions?.domain,
    path: '/',
    maxAge: constant_1.REMOVE_COOKIE_MAX_AGE,
});
exports.createAuthFlowProofCookiesRemoveOptions = createAuthFlowProofCookiesRemoveOptions;
